import { Link } from '@tanstack/react-router'
import { AlertTriangle } from 'lucide-react'
import { useTranslation } from '@kostbar/i18n'
import { useUnassignedCount } from '../hooks/use-unassigned-count'

/**
 * Points from the products list at the assignment worklist.
 *
 * The worklist lives behind Katalog → Kategorien → second tab, which nobody discovers on their own.
 * This is where the problem is actually noticed — someone is looking at articles — so this is where
 * the pointer belongs. It renders nothing when there is nothing to assign.
 */
export function UnassignedProductsHint() {
  const { t: tCategories } = useTranslation('categories')
  const count = useUnassignedCount()

  if (count === 0) return null

  return (
    <div className="mb-4 flex flex-wrap items-center gap-3 rounded-lg border border-amber-200 bg-amber-50 px-4 py-3 text-sm text-amber-900">
      <AlertTriangle className="h-4 w-4 shrink-0 text-amber-700" />
      <span className="flex-1">
        {tCategories('hint.soldWithoutGroup', { count })}
      </span>
      <Link
        to="/categories"
        className="font-medium underline underline-offset-2"
      >
        {tCategories('hint.assignNow')}
      </Link>
    </div>
  )
}
